import React from "react";

// import Sidebar from "../../../components/AdminComponents/SideNav";

import { Table, Button, Input, Modal, Form, Spin, Tag, Tooltip } from "antd";
import { useState, useRef, useEffect } from "react";
import {
  // DeleteTwoTone,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
// import "./settingStyles.css";
import { message } from "antd";
import {
  //   ClientMenu,
  CourseTopLevel,
} from "../../../components/AdminComponents/MenuItems";
import EditableImage from "../../../components/icons/EditIcon";
import Axios from "../../../api/Axios";
import { Pagination } from "antd";

import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
// import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { GetFormattedDateTime } from "../../../components/utils/DateTimeUtils";
import CatSubCatCourseModal from "./CatSubCatCourseModal";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useLocation } from "react-router-dom";
const { Item } = Form;

const Producers = () => {
  //   const handleRowClick = (record) => {
  //     //console.log(record);
  //     setModalData(record);
  //     setVisible(true);
  //   };

  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  // const onFinish = (values) => {
  //   //console.log("Form values:", values);
  // };

  const [modalData, setModalData] = useState({});
  const formRef = useRef();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const updateAuth = true;
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/producerlist/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data?.results);
        setItemsLength(res.data?.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };

  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };
  const handleViewClick = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Producer details have been ${props}.`,
      duration: 5,
    });
    LoadUser();
    if (props === "created") {
      handleReset();
    }
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Producer details have not been ${props}.`,
      duration: 5,
    });
  };
  const handleRowClick = (record) => {
    setModalData(record);
    setIsEdit(true);
    setOpen(true);
    console.log(record);
  };
  useEffect(() => {
    const loadForm = () => {
      if (formRef.current) {
        formRef.current.setFieldsValue({
          name: modalData?.name,
          wp_vender_id: modalData?.wp_vender_id,
        });
      }
    };
    if (isEdit) {
      loadForm();
    }
  }, [modalData, isEdit]);
  const columns = [
    {
      title: capitalizeWords("Producer ID"),
      dataIndex: "wp_vender_id",
      key: "wp_vender_id",
      width: 300,
    },
    {
      title: capitalizeWords("Producer Name"),
      dataIndex: "name",
      key: "name",
      width: 500,
    },
    {
      title: capitalizeWords("No. Of Courses"),
      dataIndex: "course_count",
      key: "course_count",
      width: 250, // set width to 150px
      // editable: true,
      align: "center",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {text > 0 ? (
            <Tooltip
              title="View Courses"
              onClick={() => handleViewClick(record?.id)}
            >
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            </Tooltip>
          ) : (
            <Tag
              color="default"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "not-allowed",
                borderRadius: "50%", // Make it a circle
                fontWeight: "600",
                padding: 0, // Remove padding for a perfect circle
              }}
            >
              {text}
            </Tag>
          )}
        </div>
      ),
    },

    {
      title: capitalizeWords("Last Update"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 200,
      render: GetFormattedDateTime,
      align: "center",
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("actions"),
            key: "actions",
            align: "center",
            width: 300,
            render: (text, record) => {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record}
                    key={`edit-${record.code}`}
                    disabled={false}
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
      setIsEdit(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
    setIsEdit(false);
    formRef.current.resetFields();
    setModalData({});
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleReset = () => {
    formRef.current.resetFields();
  };

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const onFinish2 = async (values) => {
    //console.log("Form values:", values);
    const allValues = {
      ...values,
      created_by: userInfo?.data?.organization?.id,
    };
    try {
      await Axios.post(`/producercreate/`, allValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("added");
    } catch (err) {
      //console.log(err);
      CreateFailed("added");
    }
  };
  const onFinishEdit = async (values) => {
    //console.log("Form values:", values);
    const allValues = {
      ...values,
      created_by: userInfo?.data?.organization?.id,
    };
    try {
      await Axios.put(`/producer/${modalData?.id}/`, allValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("edited");
    } catch (err) {
      //console.log(err);
      CreateFailed("edit");
    }
  };
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevel : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <CommonTopDetails
        title="Producer Summary"
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        // showModal={showModal}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
      />
      {/* <div className="using-class">
          <div className="search-container">
            <div className="heading-text">
              NAICS |{" "}
              <span className="gold-text-span">{itemsLength} codes(s)</span>
            </div>
          </div>

          <Input.Search
            className="search-input"
            placeholder="Search by..."
            enterButton
            value={search}
            onChange={handleSearchChange}
            key="search-input"
          />
          {updateAuth && (
            <Button
              type="primary"
              htmlType="button"
              className="setting-add"
              onClick={showModal}
            >
              + Add New
            </Button>
          )}
        </div> */}
      <Spin spinning={loading}>
        <Table
          size="small"
          dataSource={data}
          columns={columns}
          bordered
          rowKey="id"
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(24)}px`,
          }}
          className="table-container"
          style={{ margin: "1rem" }}
          pagination={false}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      <Modal
        title={
          <p className="modal-heading">
            {isEdit ? "Edit Producer" : "Add New Producer"}
          </p>
        }
        centered
        // open={modalOpen}
        // onOk={() => setModalOpen(false)}
        // onCancel={() => setModalOpen(false)}
        onOk={handleOk}
        onCancel={handleCancel}
        open={open}
        footer={[]}
      >
        <Form
          onFinish={isEdit ? onFinishEdit : onFinish2}
          style={{ marginTop: "3rem" }}
          ref={formRef}
        >
          <Item
            label={<p className="modal-text">Producer ID</p>}
            name="wp_vender_id"
            rules={[{ required: true, message: "Please input a Producer ID" }]}
            initialValue={isEdit ? modalData?.wp_vender_id : null}
          >
            <Input placeholder="Enter Producer ID" />
          </Item>
          <Item
            label={<p className="modal-text">Producer Name</p>}
            name="name"
            rules={[
              { required: true, message: "Please input a name" },
              {
                max: 100,
                message: "Title should not exceed 100 characters",
              },
            ]}
            initialValue={isEdit ? modalData?.name : null}
          >
            <Input placeholder="Enter name" />
          </Item>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              height: "2rem",
            }}
          >
            <Form.Item style={{ marginRight: "1rem" }}>
              <Button key="back" onClick={handleCancel}>
                <CloseOutlined />
                Cancel
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#f58029",
                  // fontWeight: "600",
                }}
                className="save-update-btn"
              >
                {isEdit ? "Update" : "Save"}
                <SaveOutlined />
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <CatSubCatCourseModal
        selectedRecord={selectedRecord}
        handleModalClose={handleModalClose}
        isModalVisible={isModalVisible}
        from="prod"
      />
    </WrapperComponent>
  );
};

export default Producers;
